﻿import {UISprite} from "./Tools/Base/UISprite";
import {UIButton} from "./Tools/Base/UIButton";

export class SkipEpochsOfferButton extends UIButton {

    get IsActive() {
        return this.Active;
    }

    Awake() {
        super.Awake();
        this.planetImg = this.addChild(new UISprite());
        this.SetActive(false);
        this.on("pointertap", () => Core.UI.skipEpochsOffer.Show());
        this._initTapHighlight(this.planetImg);
    }

    Check() {
        this.Update();
    }

    Update() {
        if (!Core.Player.PlanetsSave.CurrentPlanet) return;
        this.planetImg.setImage(`map/planet${Core.Player.PlanetsSave.currentPlanetId}`);
        this.SetActive(
            Core.UI.skipEpochsOffer.available
            && Core.Player.PlanetsSave.currentPlanetId != 1
            && Core.Player.PlanetsSave.CurrentPlanet.epochs.length == 1
        );
    }

    fitLayout(rect) {
        rect = rect.clone();
        this.position.copyFrom(rect);
        rect.x = rect.y = 0;
        this.planetImg.fitRect(rect);
    }
}
